import React from "react";

interface UnauthorizedBoundaryProps {
    children: React.ReactNode;
    isUnauthorized: boolean;
    ErrorComponent: React.ComponentType<any>;
}

export const UnauthorizedBoundary: React.FC<UnauthorizedBoundaryProps> = ({
    children,
    isUnauthorized,
    ErrorComponent,
}) => {
    if (!ErrorComponent) {
        console.warn("UnauthorizedBoundary: ErrorComponent is required");
        return null;
    }

    return isUnauthorized ? <ErrorComponent /> : <>{children}</>;
};
